import { useState } from 'react'
import type { TextRunStyleUpdate } from '@/lib/text/types/text-run-style-update'
import { alignmentToNumeric } from '../helpers/alignment'
import type { AlignmentUiValue } from '../types/alignment-ui-value'

interface AlignmentAndDecorationOptions {
  disabled: boolean
  hasTextSelectionTarget: boolean
  emitStyleUpdate: (update: TextRunStyleUpdate) => void
}

/** Paragraph alignment and the Underline decoration. */
export function useAlignmentAndDecoration({
  disabled,
  hasTextSelectionTarget,
  emitStyleUpdate,
}: AlignmentAndDecorationOptions) {
  const [alignment, setAlignment] = useState<AlignmentUiValue | null>(null)
  const [underlineState, setUnderline] = useState(false)

  const alignmentControlsDisabled = disabled || !hasTextSelectionTarget

  const selectAlignment = (value: AlignmentUiValue) => {
    setAlignment(value)
    emitStyleUpdate({ alignment: alignmentToNumeric(value) })
  }

  const toggleUnderline = () => {
    if (alignmentControlsDisabled) return

    const next = !underlineState

    setUnderline(next)
    emitStyleUpdate({ underline: next })
  }

  return {
    alignment,
    setAlignment,
    underlineState,
    setUnderline,
    alignmentControlsDisabled,
    selectAlignment,
    toggleUnderline,
  }
}

export type AlignmentAndDecoration = ReturnType<typeof useAlignmentAndDecoration>
